import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqs: FAQItem[] = [
  {
    question: '布丁漫画的下拉式阅读和传统翻页有什么区别？',
    answer: '布丁漫画的下拉式阅读采用自主研发的无缝加载引擎，所有漫画内容在垂直方向上连续排列，读者只需向下滑动即可流畅阅读，无需等待翻页加载。相比传统翻页模式，下拉式阅读不仅更加流畅，还能让读者维持沉浸感，阅读体验如同刷社交媒体般自然。',
  },
  {
    question: '布丁漫画是免费的吗？需要付费订阅吗？',
    answer: '布丁漫画提供海量漫画免费阅读服务。平台上超过90%的漫画内容均可免费完整阅读。我们通过广告合作和增值服务维持运营，确保大多数读者可以不花一分钱享受优质的漫画阅读体验。未来我们也可能会推出VIP会员服务，但免费阅读的核心承诺不会改变。',
  },
  {
    question: '支持哪些类型的漫画？更新频率如何？',
    answer: '布丁漫画目前覆盖韩漫、国漫、日漫三大漫画品类，细分包括耽美、玄幻、都市、悬疑、搞笑等八大分类。我们与国内外多家漫画平台和独立作者保持密切合作，大部分热门连载作品在官方更新后24小时内即可在布丁漫画上同步阅读，确保你永远不会错过任何精彩内容。',
  },
  {
    question: '如何找到我想看的漫画？',
    answer: '布丁漫画提供多种方式帮你找到心仪的漫画：你可以通过首页的分类导航浏览不同品类，使用搜索功能输入漫画名称或作者，也可以查看"高分推荐"和"最近更新"版块发现热门内容。我们的AI智能推荐系统还会根据你的阅读偏好，为你个性化推荐可能感兴趣的漫画。',
  },
  {
    question: '布丁漫画支持哪些设备阅读？',
    answer: '布丁漫画采用响应式网页设计，完美适配手机、平板和电脑等所有设备。无论你是在通勤路上用手机刷漫画，还是在家用平板大屏阅读，都能获得一致流畅的下拉式体验。无需下载任何APP，打开浏览器即可开始阅读。',
  },
  {
    question: '阅读记录会保存吗？可以离线阅读吗？',
    answer: '布丁漫画会自动保存你的阅读进度和浏览历史，下次打开时可以无缝接着上次的进度继续阅读。目前离线阅读功能正在开发中，预计将在后续版本中推出。建议在WiFi环境下提前加载漫画内容，以减少移动数据流量的消耗。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-1">
            关于布丁漫画，你想知道的都在这里
          </p>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-50 border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-900 pr-4">{faq.question}</span>
                <span className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-400"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}